import React, { Component } from 'react';
import {jsonUrl} from '../components/Factory' 
import Publikation from '../components/Publikation'; 
import Bestellen from '../components/Bestellen'; 
import Flexbox from '../components/misc/Flexbox'; 
import VisibilitySensor from 'react-visibility-sensor';

class PublikationenContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  publikations: this.props.resolves.publikations,
		  offset : 10,
		  finished:'block',
		  bestellen:'',
		  bestellenName:'',
		  bestellenPrice:''
		}
		this.onChange = this.onChange.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	handleOpen(name,price){
		this.setState({
			bestellen:'open',
			bestellenName:name,
			bestellenPrice:price
		});
		document.body.classList.toggle('no-scroll');
	}
	handleClose(data){
		this.setState({
			bestellen:''
		});
		document.body.classList.toggle('no-scroll');
	}
	onChange(isVisible){
		if(isVisible) { 
			this.loadMore();
		}
	}	
	loadMore(){
		fetch(jsonUrl({ 	number:10,
							offset:this.state.offset,
							type:'publikationen',
							orderbymeta:'menu_order',
							order:'desc'	
						}))
					  .then(res => res.json())
					  .then(res => {
							if(res.length>0)
								this.setState({
									publikations: [...this.state.publikations,...res],
									offset: this.state.offset+10
								});
							else
								this.setState({
									finished:'none'
								});
					  })
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	 
		setTimeout(function(){
			document.getElementById('menu-besuch').classList.add('active');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-besuch').classList.remove('active');
	}
	render() {		   
		   let { page } = this.props.resolves;
		   return ( 
				<div>
					<div className="container-fluid lg-side-padding">
						<div className="row">            
							<div className="col-md-12">
								<Flexbox left={page.title_left} right={page.title_right} />
								<section className="pubs-list">
									{
										this.state.publikations.map( (data,i)=>
											<Publikation staticData={this.props.resolves.staticData} handleClick={this.handleOpen} key={i} {...data} />
										)
									}
									<VisibilitySensor onChange={this.onChange}>
										<div className="loading small" style={{display:this.state.finished}}>
											<div className="one"></div>			
										</div>
									</VisibilitySensor>
								</section>
							</div>
						</div>
					</div>
					<Bestellen staticData={this.props.resolves.staticData} name={this.state.bestellenName} price={this.state.bestellenPrice} {...page} handleClick={this.handleClose} status={this.state.bestellen} />
				</div>
			)
	   
	}
}
export function getPublikations(){
	return fetch(jsonUrl({ 
						number:10,
						type:'publikationen',
						orderbymeta:'menu_order',
						order:'desc'	
					}))
				  .then(res => res.json())
				  .then(res => {					
					return res;		 
				  })
}
export default PublikationenContainer;


// WEBPACK FOOTER //
// ./src/containers/PublikationenContainer.js